import { useEffect } from 'react';

import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import usePolling from 'hooks/usePolling';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import { getCurrentApplication } from 'thunks';

const TWO_MINUTES = 2 * 60 * 1000; // 2 minutes in milliseconds

interface IBankInformationPlaidIntegrationWaitingStepProps {
  onStepComplete: () => void;
  onStepFail: () => void;
}

const BankInformationPlaidIntegrationWaitingStep = ({
  onStepComplete,
  onStepFail,
}: IBankInformationPlaidIntegrationWaitingStepProps) => {
  const { variables } = useAppSelector(getApplicationSelector)!;
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const isPlaidIntegrationsCompleted =
    variables[CuroApplicationVariables.PlaidAuthAndIdentityIntegrationsPassed] &&
    variables[CuroApplicationVariables.PlaidCraIntegrationsPassed];

  const getApplication = async () => {
    await dispatchWithUnwrap(getCurrentApplication());
  };

  usePolling({
    callback: getApplication,
    onAbort: onStepFail,
    maxTime: TWO_MINUTES,
  });

  useEffect(() => {
    if (isPlaidIntegrationsCompleted) {
      onStepComplete();
    }
  }, [isPlaidIntegrationsCompleted]);

  return <LoaderStep />;
};

export default BankInformationPlaidIntegrationWaitingStep;
